<template>
    <div
        id="notify"
        class="mr:fixed mr:z-(--notification-z-index) mr:top-0 mr:right-0 mr:w-notification-wrapper mr:m-4 mr:md:m-8 mr:max-w-modal-max"
    >
        <MrNotification
            v-for="notification in queue"
            :key="notification.uid"
            :message="notification.msg"
            :type="notification.type"
            @click="notification.expire()"
        />
    </div>
</template>

<script>
import MrNotification from '@comp/MrNotification.vue'
import NotifyService from '@serv/NotifyService'

// Initialize a singleton Notify service with the current Vue instance.
// The `data` must have a `queue` object.
export default {
    name: 'NotifyMsg',
    components: { MrNotification },
    data() {
        return {
            queue: []
        }
    },
    mounted() {
        NotifyService.init(this.queue)
    }
}
</script>
